
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { 
  Select, 
  SelectContent, 
  SelectItem, 
  SelectTrigger, 
  SelectValue 
} from '@/components/ui/select';
import AdjustmentTypeSelector from './AdjustmentTypeSelector';
import { AdjustmentType, predefinedReasons } from '../../hooks/useStockAdjustment';

interface StockAdjustmentFormProps {
  adjustmentType: AdjustmentType;
  setAdjustmentType: (type: AdjustmentType) => void;
  quantity: number;
  setQuantity: (value: number) => void;
  reason: string;
  setReason: (value: string) => void;
  notes: string;
  setNotes: (value: string) => void;
}

const StockAdjustmentForm = ({
  adjustmentType,
  setAdjustmentType,
  quantity,
  setQuantity,
  reason,
  setReason,
  notes,
  setNotes
}: StockAdjustmentFormProps) => {
  return (
    <div className="grid gap-4 py-4">
      <AdjustmentTypeSelector 
        adjustmentType={adjustmentType} 
        setAdjustmentType={setAdjustmentType} 
      />

      <div className="grid grid-cols-4 items-center gap-4">
        <Label htmlFor="quantity" className="text-right">
          Quantity
        </Label>
        <Input
          id="quantity"
          type="number"
          value={quantity}
          onChange={(e) => setQuantity(parseInt(e.target.value) || 0)}
          min="1"
          className="col-span-3"
        />
      </div>

      <div className="grid grid-cols-4 items-center gap-4">
        <Label htmlFor="reason" className="text-right">
          Reason
        </Label>
        <Select
          value={reason}
          onValueChange={setReason}
        >
          <SelectTrigger className="col-span-3">
            <SelectValue placeholder="Select a reason" />
          </SelectTrigger>
          <SelectContent>
            {predefinedReasons.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="grid grid-cols-4 items-center gap-4">
        <Label htmlFor="notes" className="text-right self-start pt-2">
          Notes
        </Label>
        <Textarea
          id="notes"
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          placeholder="Additional details about this adjustment"
          className="col-span-3"
        />
      </div>
    </div>
  );
};

export default StockAdjustmentForm;
